import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {take} from "rxjs/operators";
import {FusionAuthService} from "../../../../shared/services/fusion-auth";
import {LabSettingsService} from "../../../../shared/services/ocl";

@Injectable({
  providedIn: 'root'
})
export class ResultEntryAccessGuard implements CanActivate {
  constructor(private router: Router, private fusionAuthService: FusionAuthService, public labSettingService: LabSettingsService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>(resolve => {
      this.labSettingService.getResultEntrySettings().pipe(take(1))
        .subscribe(async config => {
          if (config.resultEntryEnabled) {
            const registrations = this.fusionAuthService.Profile.registrations;
            if (config.resultEntrySuperUser && registrations[0].roles.includes("Superuser")) {
              return resolve(true);
            }
            if (config.resultEntryClientAdmin && registrations[0].roles.includes("Client Admin")) {
              return resolve(true);
            }
            if (config.resultEntryClientBasic && registrations[0].roles.includes("Client Basic")) {
              return resolve(true);
            }
            await this.router.navigateByUrl('/login');
            return resolve(false);
          } else {
            await this.router.navigateByUrl('/login');
            return resolve(false);
          }
        });
    });
  }
}
